import { api } from '@/lib/api-manager'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'

export async function grantReview(
  requestId: string,
  data: MatchCoursesFormType
) {
  const result = await api.post(`v1/requests/request/${requestId}/grant`, data)
  return result.data
}
